<template>
  <el-dialog title="检索供应商" :visible.sync="disableDialog" width="50%">
    <el-form>
      <el-row :gutter="10">
        <el-col :span="10">
          <el-form-item label="供应商名称：" label-width="90px" label-position="left">
            <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button @click="searchFor(params.value)" type="primary">搜索</el-button>
            <el-button @click="searchReset" type>重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      border
      ref="tableRef"
      :data="list"
      height="378"
      tooltip-effect="dark"
      highlight-current-row
      v-el-table-loadmore="loadmore"
      @current-change="handleCurrentChange"
      :header-cell-style="tableHeader"
      v-loading="loadingTable"
      element-loading-text="拼命加载中请稍后..."
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column prop="suCode" show-overflow-tooltip label="供应商编号" width="100px"></el-table-column>
      <el-table-column prop="suName" show-overflow-tooltip  label="供应商名称" width="100px"></el-table-column>
      <el-table-column prop="suType" show-overflow-tooltip label="供应商类型" width="100px">
        <template slot-scope="scope">
        {{state[scope.row.suType - 1]}}
         </template>
      </el-table-column>
      <el-table-column prop="accountBalance" show-overflow-tooltip label="可用余额">
         <template slot-scope="scope">
           {{scope.row.accountBalance|priceFilterNum}}
          </template>
      </el-table-column>
      <el-table-column prop="amounts" show-overflow-tooltip label="贸易额">
         <template slot-scope="scope">
           {{scope.row.amounts|priceFilterNum}}
          </template>
      </el-table-column>
      <el-table-column prop="pcbCount" show-overflow-tooltip label="合同总数">
         <template slot-scope="scope">
           {{scope.row.pcbCount||0}}
          </template>
      </el-table-column>
      <el-table-column prop="staffUsename" show-overflow-tooltip label="联系人"></el-table-column>
    </el-table>
    <span slot="footer">
      <el-button type="primary" @click="onSubmit">确 定</el-button>
      <el-button @click="disableDialog = false">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { expressionList } from '@/components/utils/data'
import { querySuName } from '@/api/purchase/purchasePlanList'
export default {
  data () {
    return {
      state: ['平台渠道', '供应商', '厂家', '经销商'],
      retrieveSup: {},
      disableDialog: false,
      waitFeedbackEnquiryList: [], // 筛选条件
      queryParams: {}, // 搜索条件
      params: {},
      list: [],
      index: '',
      page: 1,
      pageSize: 30,
      expressionList: expressionList,
      loadingTable: false
    }
  },
  methods: {
    // 滚动加载更多
    loadmore () {
      this.page++
      this.queryProductTable(false)

      // this.getSupplierList(this.currentPage)
    },
    // 选中table
    handleCurrentChange (val) {
      this.retrieveSup = val
    },
    // 重置
    searchReset () {
      this.params = {}
      this.page = 1
      this.queryProductTable()
    },

    // 搜索
    searchFor (value) {
      this.params = {
        column: 'suName',
        expression: 'eq',
        value: value
      }
      if (this.params.value === '') {
        this.params = {}
      }
      this.queryProductTable()
    },
    // table表格数据
    // 表格获取
    queryProductTable () {
      // this.loadingTable = true
      const params = {
        criteriaVoList: [this.params],
        queryPageName: ''
      }

      querySuName(this.page, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            // this.loadingTable = false
            if (this.page === 1) {
              this.list = res.data.obj.records
            } else {
              const arrList = res.data.obj.records
              this.list = this.list.concat(arrList)
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 快速添加弹窗初始化
    onInitial (index) {
      this.list = []
      this.page = 1
      this.params = {}
      this.index = index
      this.queryProductTable()
      this.disableDialog = true
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 确定
    onSubmit () {
      if (this.retrieveSup === {}) {
        this.$message.error('请选择一个供应商')
      }
      this.disableDialog = false
      this.$emit('addSupplier', this.retrieveSup, this.index)
    }
  },
  directives: {
    'el-table-loadmore': {
      bind (el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          '.el-table .el-table__body-wrapper'
        )
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight
          if (condition) {
            binding.value()
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
